import { Reveal } from "@/components/Reveal";

const CULTURES_IMG = "https://images.unsplash.com/photo-1624067056935-593eb6595294?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAxODF8MHwxfHNlYXJjaHwzfHxwZXJzaWFuJTIwd2VkZGluZyUyMGNlbGVicmF0aW9ufGVufDB8fHx8MTc5MTkxMzgzNnww&ixlib=rb-4.1.0&q=85";

const GENRES = ["Persian", "Armenian", "Latin", "Hebrew", "Arabic", "Russian", "French", "Italian", "Top 40", "Classical", "Jazz", "Pop", "Rock"];

export const Cultures = () => (
    <section id="repertoire" data-testid="cultures-section" className="py-24 md:py-32 bg-[#0c0c0f] border-y border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-2 gap-14 items-center">
            <Reveal>
                <div className="relative overflow-hidden border border-white/10">
                    <img src={CULTURES_IMG} alt="Multicultural wedding celebration" className="w-full h-[420px] lg:h-[540px] object-cover img-luxe" loading="lazy" />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent" />
                    <p className="absolute bottom-5 left-6 text-xs uppercase tracking-[0.3em] text-[#d4af37]">Every culture. One stage.</p>
                </div>
            </Reveal>
            <Reveal delay={0.15}>
                <p className="text-xs uppercase tracking-[0.35em] text-[#d4af37] mb-4">Repertoire</p>
                <h2 data-testid="cultures-heading" className="font-serif text-4xl sm:text-5xl tracking-tight font-light text-[#fafafa]">
                    One orchestra, <em className="text-[#d4af37]">every culture.</em>
                </h2>
                <p data-testid="cultures-desc" className="mt-6 text-base sm:text-lg text-[#a1a1aa] leading-relaxed">
                    Seasoned in music from around the world, with vocalists who sing in many languages. From Sinatra to
                    Bruno Mars — Charles Aznavour, the Gipsy Kings, Andrea Bocelli, Julio Iglesias — a soundtrack
                    customized to your taste.
                </p>
                <div data-testid="genre-chips" className="mt-8 flex flex-wrap gap-2.5">
                    {GENRES.map((g) => (
                        <span key={g}
                            className="px-4 py-2 text-xs uppercase tracking-[0.15em] border border-white/15 text-[#d4d4d8] hover:border-[#d4af37] hover:text-[#d4af37] transition-colors duration-300 cursor-default">
                            {g}
                        </span>
                    ))}
                </div>
            </Reveal>
        </div>
    </section>
);
